/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 */

import { Plugin, ButtonView } from 'ckeditor5';
import bulbVideoIcon from '../../assets/block_toolbar_icons/video-regular.svg';
import { assetInsertLocation } from '../utils';

export default class BulbVideoUI extends Plugin {

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbVideoUI' as const;
  }

  /**
   * @inheritDoc
   */
  public init(): void {
    const { editor } = this;
    const { t } = editor;

    // The "simpleBox" button must be registered among the UI components of the editor
    // to be displayed in the toolbar.
    editor.ui.componentFactory.add('bulbInsertVideo', (locale) => {
      // The state of the button will be bound to the widget command.
      const command = editor.commands.get('insertVideo');

      // The button will be an instance of ButtonView.
      const buttonView = new ButtonView(locale);

      buttonView.set({
        label: t('content_block_type_VIDEO'),
        icon: bulbVideoIcon,
        tooltip: true,
        withText: true,
      });

      // Callback executed once the button is clicked:
      buttonView.on('execute', (event) => {
        const openAssetLibraryEvent = new CustomEvent('openAssetLibraryVideoType', {
          detail: {
            event,
            eventFiredFromEditor: true,
          },
        });

        window.dispatchEvent(openAssetLibraryEvent);
      });

      // Listen for the event that is going to be fired from our client that the upload was successful.
      window.addEventListener('assetLibraryVideoResponse', (event: any) => {
        assetInsertLocation(this.editor);
        editor.execute('insertVideo', event.detail.contentBlock);
      });

      // Bind the state of the button to the command.
      buttonView.bind('isOn', 'isEnabled').to(command as any, 'value', 'isEnabled');

      return buttonView;
    });
  }
}
